import clsx from "clsx";
import type { SortState } from "@/components/dataTable/tableSort";
import { toggleTimesheetTimeSort } from "@/features/timesheetFlow/lib/timesheetTimeSort";

const OPTIONS: Array<{ key: string; label: string; requiresTimeRange?: boolean }> = [
  { key: "work_date", label: "Datum" },
  { key: "person_name", label: "Mitarbeiter" },
  { key: "hours_decimal", label: "Stunden" },
  { key: "time_from", label: "Uhrzeit", requiresTimeRange: true },
  { key: "comment", label: "Beschreibung" },
];

export function TimesheetTimeSortBar({
  sort,
  showTimeRange,
  onChange,
}: {
  sort: SortState;
  showTimeRange: boolean;
  onChange: (next: SortState) => void;
}) {
  const options = OPTIONS.filter((option) => showTimeRange || !option.requiresTimeRange);

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Zeiten sortieren">
        <span className="mr-1 text-[11px] font-semibold uppercase tracking-wide text-label-tertiary">
          Sortierung
        </span>
        {options.map((option) => {
          const active = sort.key === option.key;
          return (
            <button
              key={option.key}
              type="button"
              aria-pressed={active}
              className={clsx(
                "inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition",
                active
                  ? "border-accent/40 bg-accent-soft text-accent"
                  : "border-separator bg-card text-label-secondary hover:border-accent/30 hover:text-label",
              )}
              onClick={() => onChange(toggleTimesheetTimeSort(sort, option.key))}
            >
              {option.label}
              {active ? (
                <span aria-hidden className="text-[10px] leading-none">
                  {sort.direction === "asc" ? "↑" : "↓"}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
      <p className="text-[11px] leading-snug text-label-tertiary">
        Diese Reihenfolge wird in die PDF übernommen.
      </p>
    </div>
  );
}
